import { EducationService } from 'src/app/_services/education.service';
import { AdminService } from './../../../_services/admin.service';

import { Component, OnInit } from '@angular/core';
declare var $ : any;
@Component({
  selector: 'app-index-level',
  templateUrl: './index-level.component.html',
  styleUrls: ['./index-level.component.css']
})
export class IndexLevelComponent implements OnInit {
  levelList=[]
  loading = true
  constructor(private adminService:AdminService, private educationService:EducationService) { }

  ngOnInit(): void {

    this.adminService.getLevels().subscribe(
      x=>{
        this.levelList=[{},...x]
        this.loading=false
      }
    )
    }



}
